import { render, staticRenderFns } from "./TheLayoutToolbar.vue?vue&type=template&id=d5aa5b7e&class=layout-toolbar"
import script from "./TheLayoutToolbar.vue?vue&type=script&lang=js"
export * from "./TheLayoutToolbar.vue?vue&type=script&lang=js"
import style0 from "./TheLayoutToolbar.vue?vue&type=style&index=0&id=d5aa5b7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports